export const defaultUniverseTheme = 'rookiewise'
const validUniverseThemes = [defaultUniverseTheme, 'bcd', 'bttb', 'triporate'] // Add new theme names to validUniverseThemes.

export const getUniverseThemeName = (universe: string) => {
    const universeHasCustomTheme = validUniverseThemes.includes(universe)
    return universeHasCustomTheme ? universe : defaultUniverseTheme
}
